import React from 'react'
import { css } from '@emotion/react'
import { useSelector } from 'react-redux'

import { SUI } from 'shared/ui'
import Scroller from 'components/Scroller'
import InvalidSearchMessage from 'components/App/Pages/SearchPage/InvalidSearchMessage'
import SearchErrorMessage from 'components/App/Pages/SearchPage/SearchErrorMessage'
import DemoInboxCard from 'components/TrialSetup/DemoInboxCard'
import TicketList from 'subapps/ticketing/components/TicketList'
import TicketListHeader from 'subapps/ticketing/components/TicketList/Header'
import { selectShowDemoInboxCard } from 'selectors/trial_setup'
import styles from './styles.less'

// Wraps the ticket list container and adds mouseEnter/Leave events
export default function WrappedTicketList({
  hasSearchErrored,
  isQueryStringValid,
  queryString,
}) {
  const showDemoInboxCard = useSelector(selectShowDemoInboxCard)

  return (
    <div className={styles.leftCell}>
      <SUI
        css={css`
          /* Auto-grow SUI wrapper to fill leftCell */
          &,
          & > * {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            min-height: 0px;
          }
        `}
      >
        <TicketListHeader isSidebarOpen />

        {queryString && hasSearchErrored && <SearchErrorMessage />}
        {queryString &&
          !isQueryStringValid &&
          !hasSearchErrored && (
            <Scroller className="desktopNormalScrollbarDisableRightBorder">
              <InvalidSearchMessage queryString={queryString} />
            </Scroller>
          )}
        {(!queryString || (!hasSearchErrored && isQueryStringValid)) && (
          <TicketList />
        )}
      </SUI>
      {showDemoInboxCard && <DemoInboxCard mini />}
    </div>
  )
}
